import { GetExpenseResponse, PostExpenseType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useCreateExpense = createTripMutation<
    GetExpenseResponse,
    { tripId: string; expenseData: PostExpenseType }
>({
    mutationFn: async ({ tripId, expenseData }) => {
        const response = await api.post<GetExpenseResponse>(`/trips/${tripId}/expenses`, expenseData)
        return response.data
    },
    invalidate: ({ tripId }) => [queryKeys.expenses(tripId), queryKeys.paymentsOwed(tripId)],
})
